// react-i18next initialization
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enCommon from '../locales/en/common.json'
import cyCommon from '../locales/cy/common.json'
import enShell from '../locales/en/shell.json'
import enTemplates from '../locales/en/templates.json'
import enPantry from '../locales/en/pantry.json'
import enRecipes from '../locales/en/recipes.json'
import enMealPlan from '../locales/en/meal-plan.json'
import enMore from '../locales/en/more.json'
import enGroceryList from '../locales/en/grocery-list.json'
import enOnboarding from '../locales/en/onboarding.json'
import enHome from '../locales/en/home.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon, shell: enShell, templates: enTemplates, pantry: enPantry, recipes: enRecipes, 'meal-plan': enMealPlan, more: enMore, 'grocery-list': enGroceryList, onboarding: enOnboarding, home: enHome },
      cy: { common: cyCommon },
    },
    defaultNS: 'common',
    fallbackLng: 'en',
    supportedLngs: ['en', 'cy'],
    interpolation: { escapeValue: false },
  })

export default i18n
